import { AuthProvider } from 'oidc-react';
import { buildOidcConfig } from './auth-provider-config';

// Both web and native (Capacitor WebView) use the standard in-WebView OIDC redirect
// flow. The native build serves the bundle locally at the redirect_uri host (see
// capacitor.config.ts), so the login round-trip never leaves the WebView and never
// opens an external browser — required on devices without a browser.
export const OidcAuthProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <AuthProvider {...buildOidcConfig()}>{children}</AuthProvider>
);
